import useCreateConfirmationPageHook from 'components/SubPages/Confirmation/useCreateConfirmationPageHook';

import { useUserContext } from 'hooks/useUserContext';

import {
  trackCTATapped,
  trackPayAnyoneConfirmationInfoPageViewed,
} from 'utils/segment/trackingEvents';

type UsePayAnyoneConfirmationPageApi = {
  trackCtaButtonClick: () => void;
  onGooglePlayCTAClick: () => void;
  oniOSAppStoreCTAClick: () => void;
};

function usePayAnyoneConfirmationPage(): UsePayAnyoneConfirmationPageApi {
  const [userData] = useUserContext();
  const { publicId } = userData;

  const trackPageViewed = () =>
    trackPayAnyoneConfirmationInfoPageViewed(publicId);

  const trackCtaClick = () =>
    trackCTATapped(
      'Pay Anyone',
      'Join Chime',
      'Pay Anyone Confirmation Page',
      'pay_anyone_confirmation_join_chime_button',
      publicId
    );

  // Fire segment event for Google Play Store CTA Tapped
  const onGooglePlayCTAClick = () => {
    trackCTATapped(
      'Pay Anyone',
      'Google Play Store CTA',
      'Pay Anyone Confirmation Page',
      'pay_anyone_confirmation_download_google_play_button',
      publicId
    );
    location.href =
      'https://play.google.com/store/apps/details?id=com.onedebit.chime&hl=en_US&gl=US&pli=1';
  };

  // Fire segment event for iOS App Store CTA Tapped
  const oniOSAppStoreCTAClick = () => {
    trackCTATapped(
      'Pay Anyone',
      'iOS App Store CTA',
      'Pay Anyone Confirmation Page',
      'pay_anyone_confirmation_download_iOS_app_button',
      publicId
    );
    location.href =
      'https://apps.apple.com/us/app/chime-mobile-banking/id836215269';
  };

  const { trackCtaButtonClick } = useCreateConfirmationPageHook(
    trackPageViewed,
    trackCtaClick
  );

  return {
    trackCtaButtonClick,
    oniOSAppStoreCTAClick,
    onGooglePlayCTAClick,
  };
}

export default usePayAnyoneConfirmationPage;
